import { useState, useEffect } from "react";
import { DollarSign } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { dailyEntriesService } from "../../services/api";
import { formatCurrency } from "./utils";

// Shared components
import EstimateCard from "./EstimateCard";

const LaborTab = ({
  job,
  canManageJobs,
  onSaveLaborEstimates,
  onPopulateFromBidSheet,
  hasBidSheet,
}) => {
  // Computed costs from daily entries - just the total
  const [totalLaborCost, setTotalLaborCost] = useState(0);
  const [loadingComputed, setLoadingComputed] = useState(true);

  // Fetch computed costs on mount
  useEffect(() => {
    const fetchComputedCosts = async () => {
      try {
        const { data } = await dailyEntriesService.getComputedCosts(job.id);
        setTotalLaborCost(data.labor?.total_cost || 0);
      } catch (err) {
        console.error("Failed to fetch computed costs:", err);
      } finally {
        setLoadingComputed(false);
      }
    };
    if (job?.id) fetchComputedCosts();
  }, [job?.id]);

  return (
    <div className="space-y-6">
      {/* Labor Estimates - using shared EstimateCard */}
      <EstimateCard
        title="Labor"
        estimates={job.labor_estimates || []}
        totalEstimate={job.total_labor_estimate || 0}
        canManage={canManageJobs}
        onSave={onSaveLaborEstimates}
        onPopulateFromBidSheet={onPopulateFromBidSheet}
        hasBidSheet={hasBidSheet}
        nameField="employee_name"
        idField="employee_id"
        testIdPrefix="labor-estimate"
      />

      {/* Actual Labor from Daily Entries - Simplified to just show total */}
      <Card>
        <CardHeader>
          <CardTitle className="text-lg flex items-center gap-2">
            <DollarSign className="w-5 h-5" />
            Actual Labor (from Daily Reports)
          </CardTitle>
        </CardHeader>
        <CardContent>
          {loadingComputed ? (
            <p className="text-muted-foreground text-center py-4">Loading...</p>
          ) : (
            <div className="flex items-center justify-between p-4 bg-blue-50 rounded-lg border border-blue-200">
              <span className="text-blue-800 font-medium">Total Actual Labor Cost</span>
              <span className="text-xl font-bold text-blue-700">{formatCurrency(totalLaborCost)}</span>
            </div>
          )}
          <p className="text-xs text-muted-foreground text-center mt-3">
            View the Hours Report for detailed breakdown by employee
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default LaborTab;
